<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item @click.native="breadcrumbClick(item)"
                          v-for="item in breadcrumbList" :key='item.id'>{{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <section class="filter">
      <div class="filter-category" v-if="categoryList.length">
        <div class="filter-category-label">分类：</div>
        <div class="filter-category-list">
          <div class="filter-category-item" :class="{'active': !bxscId}" @click="toggleCategory('')">全部</div>
          <div class="filter-category-item" :class="{'active': bxscId === item.bxscId.toString()}" @click="toggleCategory(item)"
               v-for="item in categoryList" :key="item.bxscId">{{ item.name }}</div>
        </div>
      </div>
      <div class="filter-category" v-if="brandList.length">
        <div class="filter-category-label">品牌：</div>
        <div class="filter-category-list">
          <div class="filter-category-item" :class="{'active': !brandId}" @click="toggleBrand('')">全部</div>
          <div class="filter-category-item" :class="{'active': brandId === item.bXyBid.toString()}" @click="toggleBrand(item)"
               v-for="item in brandList" :key="item.bXyBid">{{ item.name }}</div>
        </div>
      </div>
      <div class="filter-category">
        <div class="filter-category-label">店铺分类：</div>
        <div class="filter-category-list">
          <div class="filter-category-item" :class="{'active': !mSort}" @click="toggleStoreClass('')">全部</div>
          <div class="filter-category-item" :class="{'active': mSort === item.bxscId.toString()}" @click="toggleStoreClass(item)"
               v-for="item in storeClassList" :key="item.bxscId">{{ item.name }}</div>
        </div>
      </div>
      <div class="filter-category">
        <div class="filter-category-label">储值宝支付：</div>
        <div class="filter-category-list">
          <div class="filter-category-item" :class="{'active': !yhFlag}" @click="toggleYhPay('')">全部</div>
          <div class="filter-category-item" :class="{'active': yhFlag === 'Y'}" @click="toggleYhPay('Y')">支持</div>
          <div class="filter-category-item" :class="{'active': yhFlag === 'N'}" @click="toggleYhPay('N')">不支持</div>
        </div>
      </div>
      <div class="filter-category">
        <div class="filter-category-label">所属地区：</div>
        <div class="filter-category-list">
          <div class="filter-category-item" :class="{'active': !formInline.mLocation}" @click="locationChange(null)">全部</div>
          <el-cascader v-model="formInline.mLocation"
                       @change="locationChange"
                       :props="{ checkStrictly: true }" placeholder="请选所属地区" :options="areaDatas"></el-cascader>
        </div>
      </div>
    </section>
    <el-container v-loading="loading">
      <el-aside width="180px">
        <hotGoods navTitle="热卖商品" :hotGoodsList='lefthotGoodsList'></hotGoods>
      </el-aside>
      <el-main class="no-padding">
        <ul class="orderBy">
          <li>
            <div class="sort-item" :class="{'active': formInline.sortname === 'saleNum'}" @click="toggleSort('saleNum')">热销</div>
          </li>
          <li>
            <div class="sort-item" :class="{'active': formInline.sortname === 'createTime'}" @click="toggleSort('createTime')">上新</div>
          </li>
          <li>
            <div class="sort-item":class="{'active': formInline.sortname === 'price_up' || formInline.sortname === 'price_down'}" @click="toggleSort('price')">
              <span>价格</span>
              <i class="el-icon-arrow-up" v-if="formInline.sortname === 'price_up'"></i>
              <i class="el-icon-arrow-down" v-else></i>
            </div>
          </li>
          <li>
            <el-input class="priceInput min" size="mini" v-model="formInline.priceMin" placeholder="最低价"></el-input>
            <span class="line"></span>
            <el-input class="priceInput max" size="mini" v-model="formInline.priceMax" placeholder="最高价"></el-input>
            <el-button type="primary" plain size="mini" @click="priceRangeSearch">确定</el-button>
            <el-button type="default" plain size="mini" @click="resetPriceRange">清空</el-button>
          </li>
        </ul>
        <div class="product-list" v-if="rightGoodsList.length">
          <template v-for="item in rightGoodsList">
            <good-card :good="item" :key="item.id"></good-card>
          </template>
        </div>
        <empty v-else>暂无相关商品！</empty>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import hotGoods from '@/components/hotGoods';
import GoodCard from '@/components/good-card';
import "@/assets/css/base.css";
import {commoditylist, categorylist, storeClassList, fetchBrandList} from "../../api/xunyou";
import Pagination from '../../components/Pagination';
export default {
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      loading: false,
      categoryList: [],
      storeClassList: [],
      rightGoodsList: [],
      brandList: [],
      // 分页参数
      pageparm: {
        pageSize: 12,
        currentPage: 1,
        total: 0,
      },
      formInline: {
        pageSize: 12,
        pageNum: 1,
        cid: '',
        stype: 2,
        sortway: false,
        sortname: 'saleNum',
        yhFlag: '', // Y-支持 N-不支持，，全部时不传
        mLocation: '',
        mSort: '',
        priceMin: '',
        priceMax: ''
      }
    };
  },
  // 注册组件
  components: {
    hotGoods,
    GoodCard,
    Pagination
  },
  watch: {
    '$route': function (to, from) {
      console.log('路由数据：', to);
      this.search();
      this.getCategoryList();
    }
  },
  computed: {
    areaDatas () {
      return this.$store.state.getprovince;
    },
    // 热门商品就这么来的？良心不会痛吗？
    lefthotGoodsList () {
      return this.rightGoodsList.slice(0, 4);
    },
    adWord () {
      return this.$route.query.adWord || '';
    },
    brandId () {
      return this.$route.query.brandId || '';
    },
    bxscId () {
      return this.$route.query.bxscId || '';
    },
    bxscName () {
      return this.$route.query.bxscName || '';
    },
    yhFlag () {
      return this.$route.query.yhFlag || '';
    },
    mSort () {
      return this.$route.query.mSort || '';
    },
    mLocationParams () {
      return this.$route.query.mLocation || '';
    },
    breadcrumbList () {
      const list = [
        { id: -1, name: '首页', path: '/' },
        { id: 0, name: '全品类', path: '/goodsList' }
      ];
      if (this.$route.query.bxscId) {
        list.push({ id: this.bxscId, name: this.bxscName, path: `/goodsList?bxscId=${this.bxscId}&bxscName=${this.bxscName}` });
      }
      return list;
    }
  },
  mounted() {
    this.search();
    this.getCategoryList();
    this.getStoreClassList();
    this.initLocation();
  },
  methods: {
    // 往URL上追加参数
    appendQueryToUrl (query) {
      let obj = {};
      let queryStr = window.location.search.substring(1);
      if (queryStr) {
        let vars = queryStr.split('&');
        for (let i=0; i < vars.length; i++) {
          let pair = vars[i].split('=');
          obj[pair[0]] = pair[1];
        }
      }
      for (let key in query) {
        if (query.hasOwnProperty(key)) {
          obj[key] = query[key];
        }
      }
      if (obj.toString() === '{}') {
        this.$router.push('/goodsList');
      } else {
        const strs = [];
        for (let key in obj) {
          if (obj[key]) {
            strs.push(`${key}=${obj[key]}`);
          }
        }
        this.$router.push(`/goodsList?${strs.join('&')}`);
      }
    },
    // 切换子分类
    toggleCategory(cate) {
      this.appendQueryToUrl({ bxscId: cate.bxscId, bxscName: cate.name });
      this.getBrandListByCategory();
    },
    // 回填选择的地区参数
    initLocation () {
      const code = this.$utils.getQueryString('mLocation');
      if (code) {
        let codes = [parseFloat(`${code.substr(0,2)}0000`)]
        if (code.length >= 4) {
          codes.push(parseFloat(`${code.substr(0,4)}00`))
        }
        if (code.length >= 6) {
          codes.push(parseFloat(code));
        }
        this.formInline.mLocation = codes;
      }
    },
    // 选择的地区
    locationChange (e) {
      console.log('选择地址：', e);
      let code = null;
      if (e) {
        code = this.getLocationCode();
      } else {
        this.formInline.mLocation = [];
      }
      this.appendQueryToUrl({ mLocation: code });
    },
    // 选择店铺分类
    toggleStoreClass (item) {
      this.appendQueryToUrl({ mSort: item.bxscId });
    },
    // 是否支持储值宝支付选择
    toggleYhPay (item) {
      this.appendQueryToUrl({ yhFlag: item });
    },
    // 选择品牌
    toggleBrand (brand) {
      this.appendQueryToUrl({ brandId: brand.bXyBid });
    },
    getBrandListByCategory () {
      this.brandList = [];
      if (this.brandId) {
        this.toggleBrand(''); // 清空之前选择的品牌
      }
      if (!this.bxscId) return;
      fetchBrandList({cId: this.bxscId})
        .then(res => {
          console.log('品牌列表：', res);
          if (res.code === 0) {
            this.brandList = res.rows.filter(ele => ele.bXyBid);
          }
        })
        .catch(err => {
          console.error('错误：', err);
        })
        .finally(() => {})
    },
    // 面包屑点击
    breadcrumbClick(item) {
      this.$router.push(item.path);
    },
    // 切换排序方式
    toggleSort(type) {
      if (type === 'price') {
        if (this.formInline.sortname === 'price_up') {
          this.formInline.sortname = 'price_down';
        } else {
          this.formInline.sortname = 'price_up';
        }
      } else {
        this.formInline.sortname = type;
      }
      this.getGoodsList();
    },
    // 情空价格区间
    resetPriceRange () {
      this.formInline.priceMin = '';
      this.formInline.priceMax = '';
    },
    // 价格区间筛选
    priceRangeSearch () {
      if (!this.formInline.priceMin || !this.formInline.priceMax) {
        this.$message.warning('请输入完整的价格区间');
        return ;
      }
      if (this.formInline.priceMin > this.formInline.priceMax) {
        let temp = this.formInline.priceMax;
        this.formInline.priceMax = this.formInline.priceMin;
        this.formInline.priceMin = temp;
      }
      this.getGoodsList();
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getGoodsList();
    },
    // 商品列表分类
    getCategoryList() {
      categorylist({parentBxscId: this.bxscId || 0}).then((res) => {
        console.log("子分类", res);
        if (res.code === 0) {
          this.categoryList = res.data;
        }
      }).catch((err) => {
        this.$message.error("查询商品分类失败，请稍后再试！");
      });
    },
    // 店铺分类
    getStoreClassList () {
      storeClassList().then(res => {
        console.log('店铺分类：', res);
        if (res.code === 0 ) {
          this.storeClassList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.$message.error('查询失败，请稍后再试！')
      })
    },
    // 查询
    search() {
      this.formInline.pageNum = 1;
      this.formInline.sortname = 'saleNum';
      this.formInline.sortway = false;
      this.getGoodsList();
    },
    // 转换地区编码格式为后端需要的格式
    getLocationCode () {
      let code = '';
      if (this.formInline.mLocation.length) {
        const sliceLen = this.formInline.mLocation.length * 2;
        const sliceCode = this.formInline.mLocation[this.formInline.mLocation.length - 1];
        code = sliceCode.toString().substr(0, sliceLen);
      }
      return code;
    },
    // 查询商品列表
    getGoodsList() {
      const params = {
        pageSize: this.formInline.pageSize,
        pageNum: this.formInline.pageNum,
        cid: this.bxscId,
        stype: 2,
        sortway: false,
        sortname: this.formInline.sortname,
        name: this.adWord,
        brandId: this.brandId,
        mLocation: this.mLocationParams,
        mSort: this.mSort,
        yhFlag: this.yhFlag,
        priceMin: this.formInline.priceMin,
        priceMax: this.formInline.priceMax
      };
      // 奇怪的逻辑：sortway只有价格升序的时候应该为TRUE；否则，会导致其它排序不起作用
      if (this.formInline.sortname === 'price_up') {
        params.sortway = true;
        params.sortname = 'price';
      }
      if (this.formInline.sortname === 'price_down') {
        params.sortway = false;
        params.sortname = 'price';
      }
      this.loading = true;
      commoditylist(params).then(res => {
        console.log('商品列表：', res);
        if (res.code === 0) {
          this.rightGoodsList = res.rows;
          this.pageparm.total = res.total;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.$message.error('请求失败，请稍候重试');
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped lang='less'>
.filter{
  margin-bottom: 10px;
  background-color: #fff;
}
/deep/ .el-cascader {
  width: 320px;
  .el-input .el-input__inner{
    height: 30px;
    line-height: 30px;
  }
}
.filter-category{
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  border-bottom: 1px solid #F5F5F5;
  padding: 10px 0;
  .filter-category-label{
    width: 100px;
    padding: 5px 10px;
    font-weight: bold;
    font-size: 14px;
  }
  .filter-category-list{
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .filter-category-item{
      padding: 5px 15px;
      color: #333333;
      cursor: pointer;
      &:hover{
        color: var(--main-theme-color);
      }
      &.active{
        color: var(--main-theme-color);
      }
    }
  }
}

.breakcrumbHeader {
  margin: 15px 0;
  /deep/ .el-breadcrumb__inner:hover {
    color: var(--main-theme-color);
    cursor: pointer;
  }
}

.orderBy {
  width: 100%;
  li {
    display: inline-block;
    margin-left: 10px;
  }
  .line{
    display: inline-block;
    width: 10px;
    border-bottom: 1px solid #DCDFE6;
    vertical-align: middle;
  }
  .sort-item{
    background: #fff;
    color: #333;
    border: 1px solid #DCDFE6;
    font-size: 12px;
    padding: 4px 15px;
    line-height: 20px;
    cursor: pointer;
    border-radius: 4px;
    &.active {
      background: var(--main-theme-color);
      border-color: var(--main-theme-color);
      font-weight: bold;
      color: #FFFFFF;
    }
  }
  .priceInput{
    display: inline-block;
    width: 80px;
    &.max{
      margin-right: 10px;
    }
  }
}

.no-padding {
  padding: 0;
}
.product-list{
  min-height: 500px;
  padding: 10px 5px;
  .product{
    margin: 0 5px 10px 5px;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/goodsList/index.vue